import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  return `The ${field} cannot be later than Expiry Date.`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var expDate = args[0]
    if (expDate) {
      // if (isAfter(removeTime(effDate), removeTime(value))) {
      //   return false
      // } else {
      //   return true
      // }
      return !(isAfter(removeTime(value), removeTime(expDate)))
    } else {
      return true
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
